import React from 'react'

const Footer = () => {
  return (
    <footer>
      <section id="footer">
        {/* <h2>Contact</h2> */}
        <ul>
          <li><strong>Phone:  </strong>+61 472 808 657</li>
          <li><strong>Email:  </strong>frank.lavery@westnet.com.au</li>
          <li><a href="https://github.com/Cancer2806" target="blank">Github</a></li>
          <li><a href="https://www.linkedin.com/in/frank-lavery-94444239/" target="blank">LinkedIn</a></li>
        </ul>
      </section>
      <h4>Thanks for Viewing my Evergrowing Portfolio 😉</h4>
    </footer>
  )
}

export default Footer